import { InstructorsActionTypes } from '../constants/actionTypes';

export default {
  GET_INSTRUCTORS: (payload, meta) => ({
    meta,
    payload,
    type: InstructorsActionTypes.GET_INSTRUCTORS
  })
};
